import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { LockService } from "../../services/lock.service";

@Injectable({ providedIn: 'root' })
export class SessionLockGuard implements CanActivate {
  constructor(private sessionLock: LockService) { }

  canActivate(): boolean {
    return !this.sessionLock.isLocked();
  }
}
